<template>
  <div class="space-y-4">
    <ExteriorAreaForm
      v-for="(area, index) in value"
      :key="area.id"
      :index="index"
      :value="area"
      @input="(area) => updateArea(area, index)"
      @delete="(index) => deleteArea(index)"
    />
    <AddButton @click="addArea" />
  </div>
</template>

<script>
import AccordionMixin from "./AccordionMixin.vue";
import ExteriorAreaForm from "../AreaForms/ExteriorAreaForm.vue";
import AddButton from "../ui/AddButton.vue";

export default {
  name: "ExteriorAreaAccordion",

  components: { ExteriorAreaForm, AddButton },

  mixins: [AccordionMixin],

  methods: {
    newArea() {
      return this.config.areas.EXTERIOR_AREA_DEFAULTS[
        this.config.areas.EXTERIOR_AREA_TYPES.HOUSE
      ];
    },
  },
};
</script>
